import { render, staticRenderFns } from "./SideCenterIntegrations.vue?vue&type=template&id=8308883a&scoped=true"
import script from "./SideCenterIntegrations.vue?vue&type=script&lang=js"
export * from "./SideCenterIntegrations.vue?vue&type=script&lang=js"
import style0 from "./SideCenterIntegrations.vue?vue&type=style&index=0&id=8308883a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8308883a",
  null
  
)

export default component.exports